import { ModuleDefinition, FlexVCNode } from "src/typings/flexFramework/FlexComponent";
import { getNameFromModuleDefinition } from "src/stores/TemplateStore";

/**
 * creates ViewComposition equivalent of provided ModuleDefintion
 * @param  {ModuleDefinition} moduleDefinition
 * @param {boolean} includeDescendants - Default TRUE. If true, all descendants will be converted to IViewComposition objects while populating it's childNodes. If false, childNodes will not be populated
 * @returns IViewComposition
 */
export const moduleDefinitionToViewCompositionNode = (
  moduleDefinition: ModuleDefinition,
  includeDescendants: boolean = true
): FlexVCNode => {
  let view = getNameFromModuleDefinition(moduleDefinition);
  const flexComponentView = moduleDefinition.view ? moduleDefinition.view : undefined;

  if (flexComponentView && flexComponentView !== "default") {
    view = `${view}_${flexComponentView}`;
  }

  //TODO: remove complexity here when we start getting id's consistently from the template for all components
  const id = moduleDefinition.id;

  const options = {
    ...moduleDefinition,
    flexComponentView,
  } as any;

  delete options.id;
  delete options.name;
  delete options.modules;
  delete options.children;
  delete options.groups;
  delete options.view;

  if (
    getNameFromModuleDefinition(moduleDefinition) === "tab" ||
    getNameFromModuleDefinition(moduleDefinition) === "region"
  ) {
    options.containerName = moduleDefinition.name;
  }

  const viewComposition: FlexVCNode = {
    id,
    view,
    options,
  };

  if ((moduleDefinition.modules || moduleDefinition.groups || moduleDefinition.children) && includeDescendants) {
    //TODO: all children are assumed as array type since this matches Template and Composition structure. How to use map type children via Template or Composition?

    // gather and create decendant BlossomComponents
    const childModuleDefinitions: ModuleDefinition[] = [
      ...(moduleDefinition.modules || []),
      ...(moduleDefinition.groups || []),
      ...(moduleDefinition.children || []),
    ];

    const childNodes = childModuleDefinitions
      .map((child) => moduleDefinitionToViewCompositionNode(child))
      .filter((node) => !!node);

    if (childNodes.length > 0) {
      viewComposition.childNodes = childNodes;
    }
  }

  return viewComposition;
};
